/* eslint-disable default-case */
import produce from 'immer';
import { getStaff, updateStaff, setLocation } from './actions';

const initialState = {
  staff: [],
  location: null,
  loading: false,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case getStaff.TRIGGER:
      draft.loading = true;
      break;
    case getStaff.SUCCESS:
      draft.staff = payload;
      break;
    case updateStaff.toString(): {
      const foundIndex = draft.staff.findIndex((x) => x.id === payload.id);
      const newList = [...draft.staff];
      newList[foundIndex] = payload;
      draft.staff = newList;
      break;
    }
    case setLocation.toString():
      draft.location = payload;
      break;
    case getStaff.FULFILL:
      draft.loading = false;
      break;
  }
}, initialState);

export default reducer;
